jQuery(document).ready(function ($) {
  function setSecondaryNav() {
    $(".cs-secondary-nav").insertAfter($(".tdk-nav-primary"));
    $(".holiday-popup").insertBefore($(".tdk-nav-primary"));
    var pxHeight = $(".tdk-nav-primary").outerHeight();
    var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var remHeight = pxHeight / rootFontSize;

    $(".tdk-nav-primary-wrapper").css({
     height: remHeight + "rem"
    });
  }

  // Call setSecondaryNav initially and on window resize
  setSecondaryNav();
  $(window).on("resize", function () {
    setSecondaryNav();
  });

  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $(".tdk-navbar-stack-fixed").outerHeight();
  var didScroll;

  $(window).scroll(function () {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 1); // Check scroll position every millisecond

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If current scroll position is greater than last scroll position
    if (st > lastScrollTop) {
      // Scroll down
      if (st > navbarHeight) {
        $(".tdk-navbar-stack-fixed").addClass("hidenav").removeClass("shownav");
      } else {
        $(".tdk-navbar-stack-fixed")
          .css("position", "relative")
          .removeClass("hidenav")
          .addClass("shownav");
      }
    } else {
      // Scroll up
      if (st + $(window).height() < $(document).height()) {
        $(".tdk-navbar-stack-fixed")
          .css("position", "fixed")
          .removeClass("hidenav")
          .addClass("shownav");
      }
    }

    lastScrollTop = st;
  }
});

function moveAlertBeforeNav() {
  const banner = document.getElementById("alertBanner");
  const navWrapper = document.querySelector(".tdk-navbar-stack-fixed");

  if (banner && navWrapper) {
    navWrapper.insertBefore(banner, navWrapper.firstChild);

    if (typeof setSecondaryNav === "function") {
      setSecondaryNav();
    }
  }
    return;
  setTimeout(moveAlertBeforeNav, 100);
}

moveAlertBeforeNav();


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) {
    const navbar = document.querySelector("#navdrop");

    const dropdownMenus = [];

    const menu1 = {
      button: document.querySelector("#nav-list-products .nav-link"),
      menu: document.querySelector("#nav-list-products .dropdown-menu.yamm-content"),
    };

    const menu2 = {
      button: document.querySelector("#nav-list-products2 .nav-link"),
      menu: document.querySelector("#nav-list-products2 .dropdown-menu.yamm-content2"),
    };

    const menu3 = {
      button: document.querySelector("#nav-list-products3 .nav-link"),
      menu: document.querySelector("#nav-list-products3 .dropdown-menu.yamm-content3"),
    };

    if (menu1.button && menu1.menu) dropdownMenus.push(menu1);

    // Teradek extra menu (only added if it exists)
    const teradekButton = document.querySelector("#nav-list-products-new .nav-link");
    const teradekMenu = document.querySelector("#nav-list-products-new .dropdown-menu.yamm-content");

    if (teradekButton && teradekMenu) {
      dropdownMenus.push({
        button: teradekButton,
        menu: teradekMenu,
      });
    }

    if (menu2.button && menu2.menu) dropdownMenus.push(menu2);
    if (menu3.button && menu3.menu) dropdownMenus.push(menu3);

    const navOverlay = document.createElement("div");
    navOverlay.classList.add("nav-overlay");
    document.body.appendChild(navOverlay);

    let activeDropdown = null;

    function showDropdown(dropdown) {
      if (activeDropdown && activeDropdown !== dropdown) {
        hideDropdown(activeDropdown);
      }
      dropdown.menu.classList.add("show");
      dropdown.button.classList.add("active");
      activeDropdown = dropdown;
      showOverlay();
    }

    function hideDropdown(dropdown) {
      dropdown.menu.classList.remove("show");
      dropdown.button.classList.remove("active");
      if (activeDropdown === dropdown) {
        activeDropdown = null;
      }
      hideOverlay();
    }

    function hideAllDropdowns() {
      dropdownMenus.forEach((dropdown) => {
        hideDropdown(dropdown);
      });
    }

    function showOverlay() {
      navOverlay.classList.add("active");
    }

    function hideOverlay() {
      if (!activeDropdown) {
        navOverlay.classList.remove("active");
      }
    }

    if (navbar) {
      navbar.addEventListener("mouseenter", function () {
        if (activeDropdown) {
          showDropdown(activeDropdown);
        }
      });

      navbar.addEventListener("mouseleave", function () {
        if (activeDropdown) {
          hideDropdown(activeDropdown);
        }
      });
    }

    dropdownMenus.forEach(function (dropdown) {
      dropdown.button.addEventListener("mouseenter", function () {
        showDropdown(dropdown);
      });

      dropdown.menu.addEventListener("mouseenter", function () {
        showDropdown(dropdown);
      });

      dropdown.menu.addEventListener("mouseleave", function (event) {
        if (!navbar.contains(event.relatedTarget)) {
          hideDropdown(dropdown);
        }
      });

      dropdown.button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        showDropdown(dropdown);
      });

      dropdown.menu.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    });

    const navIcons = document.querySelector(".nav-icons");

    if (navIcons) {
      navIcons.addEventListener("mouseenter", function () {
        hideAllDropdowns();
      });
    }

    document.addEventListener("click", function (event) {
      if (activeDropdown && !navbar.contains(event.target)) {
        hideDropdown(activeDropdown);
      }
    });
  }
});





// chnage toggle icon when menu open //
// jQuery(document).ready(function ($) {
//   $("#mobile-menu-toggle").click(function () {
//     // Toggle the aria-expanded attribute
//     $(this).attr("aria-expanded", function (_, attr) {
//       return attr === "true" ? "false" : "true";
//     });

//     // Toggle the visibility of the icon based on the aria-expanded attribute
//     $(this).find(".fa-bars").toggleClass("d-none");
//     $(this).find("#closer").toggleClass("d-block");

//     $("body").toggleClass("overflow-hidden");
//     // Toggle the height of navbar-collapse based on aria-expanded
//     var isExpanded = $(this).attr("aria-expanded") === "true";
//     $(".navbar-collapse").css("height", isExpanded ? "100vh !important" : "0");
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const accordionButtons = document.querySelectorAll(".accordion-button");

  accordionButtons.forEach(button => {
      button.addEventListener("click", function () {
          const accordionItem = this.closest(".accordion-item");

          document.querySelectorAll(".accordion-item:not(.product-accordion-item)").forEach(item => {
              item.classList.remove("active");
          });

          if (this.classList.contains("collapsed")) {
              accordionItem.classList.remove("active");
          } else {
              accordionItem.classList.add("active");
              

          }
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".heading").forEach(function (el) {
    var link = el.querySelector("a");
    if (link && link.getAttribute("href") === "#column") {
      el.style.display = "none";
    }
  });
});


function equalizeFirstWrappers(containerSelector) {
  // select all .item under the container
  const items = Array.from(document.querySelectorAll(containerSelector + ' .item'));
  if (!items.length) return;

  // collect the first .sub-link-wrapper inside each item (if exists)
  const wrappers = items
    .map(item => item.querySelector('.sub-link-wrapper'))
    .filter(el => el !== null);

  console.log('Found first wrappers:', wrappers.length);
  if (!wrappers.length) return;

  // reset previous minâ€‘height / height
  wrappers.forEach(w => {
    w.style.minHeight = '';
    w.style.height = '';
  });

  // measure actual heights
  const heights = wrappers.map(w => w.getBoundingClientRect().height);
  console.log('Wrapper heights:', heights);

  const tallest = Math.max(...heights, 0);
  if (tallest === 0) {
    console.warn('Tallest firstâ€‘wrapper height is 0 â€” maybe wrappers are hidden or not rendered yet.');
    return;
  }

  // apply min-height (or height) to all first wrappers
  wrappers.forEach(w => {
    w.style.minHeight = tallest + 'px';
    // or: w.style.height = tallest + 'px';
  });
}

window.addEventListener('load', () => {
  equalizeFirstWrappers('.inside-container');
});
window.addEventListener('resize', () => {
  equalizeFirstWrappers('.inside-container');
});


// mobile menu

// Update Back Button
function updateBackButton(backText = "All") {
  const backBtn = document.getElementById("backBtn");

  if (backText) {
      backBtn.innerHTML = `
          <a href="#" id="backBtnLink" class="text-gray-2 text-decoration-none me-1">
              <i class="fa-regular fa-chevron-left"></i>
          ${backText}</a>`;
      backBtn.style.visibility = "visible";

      document.getElementById('backBtnLink').addEventListener("click", function (e) {
          e.preventDefault();
          goBack();
      });
  } else {
      backBtn.style.visibility = "hidden";
  }
}

const menuStack = [];

function goBack() {
  const previousMenu = menuStack.pop();

  if (previousMenu) {
      previousMenu.classList.remove("active");
      previousMenu.classList.add("slide-back");
      setTimeout(() => {
          previousMenu.classList.remove("slide-back");
      }, 250);
  }

  const activeMenu = menuStack[menuStack.length - 1];

  if (activeMenu) {
      const backText = activeMenu.dataset.backText || "All";
      updateBackButton(backText);
      activeMenu.classList.add("active");
      activeMenu.classList.remove("previous");
  } else {
      updateBackButton(null);
  }
}

// Toggle Submenu
function toggleSubMenu(menuClass, backText) {
  const menu = document.querySelector(menuClass);

  if (menu) {
    const currentActive = menuStack[menuStack.length - 1];

    if (currentActive) {
      currentActive.classList.add("previous");
    }

    menu.classList.add("active");
    menu.classList.remove("previous");

    if (menu.dataset.parentText) {
      backText = menu.dataset.parentText;
    }

    menuStack.push(menu);
    updateBackButton(backText);
  }
}

function addMenuListener(id, menuClass) {
  const element = document.getElementById(id);

  if (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      toggleSubMenu(menuClass, "All");
    });
  }
}

addMenuListener("mobPrdcts", ".mobfrstMenu");
addMenuListener("mobSolution", ".mobSecndMenu"); // Only exists in Teradek
addMenuListener("newTrnding", ".mobthrdMenu");
addMenuListener("mobSprt", ".mobforthMenu");
addMenuListener("mobAbt", ".mobfifthMenu");

function attachDynamicListeners() {
  const dynamicLinks = document.querySelectorAll('[id^="sub"]');

  dynamicLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      const linkTitle = link.id.replace("sub", "").replace("Links", "").replace(/\s+/g, "").replace(/\//g, "");
      const escapedMenuClass = CSS.escape(`mob${linkTitle}Menu`);
      const menuClass = `.${escapedMenuClass}`;
      const parentText = link.getAttribute("data-back-text") || "All";
      const childMenu = document.querySelector(menuClass);

      if (childMenu) {
        e.preventDefault();
        childMenu.dataset.parentText = parentText;
        toggleSubMenu(menuClass, parentText);
      } else {
        const href = link.getAttribute("href");
        if (href && href !== "null" && href !== "/pages/null" && href.trim() !== "") {
          window.location.href = href;
        } else {
          e.preventDefault(); // stop bad redirects
          console.warn("Blocked bad redirect for link:", link);
        }
      }
    });
  });
}

attachDynamicListeners();


// to hide chat and notification
document.addEventListener('DOMContentLoaded', function () {
    const offcanvas = document.querySelector('.offcanvas-mob');

    function toggleElements(show) {
        const display = show ? 'block' : 'none';

        const chat = document.getElementById('shopify-chat');
        if (chat) chat.style.display = display;

        const pushOptin = document.getElementById('pushengage-opt-in-4');
        if (pushOptin) pushOptin.style.display = display;
    }

    function disableScroll() {
        document.documentElement.style.overflow = 'hidden'; // <html>
        document.body.style.overflow = 'hidden';            // <body>
    }

    function enableScroll() {
        document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';
    }

    if (offcanvas) {
        offcanvas.addEventListener('show.bs.offcanvas', function () {
            toggleElements(false);
            disableScroll();
        });

        offcanvas.addEventListener('hide.bs.offcanvas', function () {
            toggleElements(true);
            enableScroll();
        });
    }

});